import { TFunction } from 'i18next'
import { NumberSchema, number } from 'yup'

import { emptyStringToUndefined } from '@/Shared/ui/form'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const nonEmptyPositiveNumberSchema = (
  t: TFunction<'translation', undefined>,
  max = Number.MAX_SAFE_INTEGER,
  isInteger = false,
  min = 0,
): NumberSchema<number> => {
  let schema = number()
    .typeError(t(formTranslation.errors.fieldRequired))
    .transform(emptyStringToUndefined)
    .min(min, t(formTranslation.errors.notZero))
    .max(max, t(formTranslation.errors.maxAllowed) + ' ' + max)
    .required(t(formTranslation.errors.fieldRequired))

  if (isInteger) {
    schema = schema.test(
      'is-integer',
      t(formTranslation.errors.notInteger),
      number => number === undefined || Number.isInteger(number),
    )
  }

  return schema
}
